module.exports = "<div ng-controller=DataEnvironmentController> <div ng-show=!dataEnvironments.available>Loading</div> <div ng-show=dataEnvironments.available> <span ng-show=!activeDataEnvironment.available>Choose</span><span ng-show=activeDataEnvironment.available>Switch</span> account: <ul> <li ng-repeat=\"dataEnvironment in dataEnvironments.list\"> <i class=\"fa fa-dashboard\" ng-show=\"dataEnvironment.slug === activeDataEnvironment.slug\"></i> <a href=javascript:void(0); ng-click=setDataEnvironment(dataEnvironment.slug);>{{dataEnvironment.slug}}</a> </li> </ul> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/views/domain/choose-current.html
// module id = 4191
// module chunks = 86